// extracted by mini-css-extract-plugin
module.exports = {"__next":"__next"};